import type { NavigationItemType } from '@oppy/omniv2-core';
import type { IconProps } from '@oppy/omniv2-ui';
import { AppLink, cn, faCircle, Icon } from '@oppy/omniv2-ui';

type Props = NavigationItemType & {
  isActive?: boolean;
  isSubItem?: boolean;
};

export default function NavigationItem({
  href,
  label,
  iconProps,
  isActive = false,
  isSubItem = false,
}: Props) {
  const appLinkIconProps: IconProps = iconProps ?? {
    icon: faCircle,
  };

  return (
    <AppLink
      to={href}
      data-testid="nav-item"
      className={cn('flex items-center rounded-r-full h-10 transition-all', {
        'bg-hover-link': isActive && isSubItem,
        'bg-gradient-to-r from-main-nav-start to-main-nav-end text-white shadow':
          isActive && !isSubItem,
        'hover:bg-hover-link': !isActive,
      })}
    >
      <Icon {...appLinkIconProps} className="size-3 px-6" />
      {label}
    </AppLink>
  );
}
